/*eslint-disable*/

$('body').on('click', '.resource', function(event) {

  var id = $(this).attr('id');

  var $wrapper = $('#' + id).children('.library__collapse');

  // prevent link clicking from closing dropdown
  if($(this).hasClass('active') && event.target.nodeName.toLowerCase() != 'a') {
    $(this).removeClass('active');
    $wrapper.slideUp();
  } else {
    $wrapper.slideDown();
    $(this).addClass('active');
  }
});

$('#libraryTabs li a').click(function() {
  if($(this).attr('data-target') == '#searchtab') {
    $('.library__search').slideDown();
  } else {
    // hide extras when clicking another tab
    $('.library__search').slideUp();
    $('.alphabet-hide').css({ 'opacity': '0', 'height': '0'});
  }
});

$('body').on('click', '.clearresultslibrary', function() {  
  $('.library__search_results').empty();
  $('.alphabet-hide').css({ 'opacity': '0', 'height': '0'});
  $('#librarySearch input').val('');
});

// Ajax resource subjects

$('#subject .library__container').click(function(event) {

  var $subject_id = $(this).attr('id');
  var $container = $('#' + $subject_id).children('.sponsor__info');

  console.log(event.target);

  // check to see if sponsor info div is a parent of what was clicked, if yes then it shouldn't close. Also check that it is already active and not a link
  if(!$('.sponsor__info').has(event.target).length && $(this).hasClass('active') && event.target.nodeName.toLowerCase() != 'a') {
    $(this).removeClass('active');
    $container.slideUp();
    $container.empty();
  } else if(event.target.nodeName.toLowerCase() == 'a') {
    // do nothing so link can open!
  } else if($('.sponsor__info').has(event.target).length) {
    // preventDefault makes interior div close more smoothly
    event.preventDefault();
  } else {
    // the div loads its content!
    $(this).addClass('active');

    jQuery.ajax({
      type       : "GET",
      data       : { 
        dataType   : "jsonp",
        action:'ajax_library_subjects',
        subject: $subject_id,
      },
      url: '../../wp-admin/admin-ajax.php',
      success    : function(data){
        if(data.length) {
          var content = data;
          $container.hide().slideDown();
          $(content).hide().appendTo($container).slideDown();
        }
      },
    });
  }
});

// Author dropdown

$('body').on('click', '#author .library__container', function(event) {

  var $author_id = $(this).attr('id');
  var $container = $('#' + $author_id).children('.sponsor__info');

  // check to see if sponsor info div is a parent of what was clicked, if yes then it shouldn't close. Also check that it is already active and not a link
  if(!$('.sponsor__info').has(event.target).length && $(this).hasClass('active') && event.target.nodeName.toLowerCase() != 'a') {
    $(this).removeClass('active');
    $container.slideUp();
  } else if(event.target.nodeName.toLowerCase() == 'a') {
    // do nothing so link can open!
  } else if($('.sponsor__info').has(event.target).length) {
    // preventDefault makes interior div close more smoothly
    event.preventDefault();
  } else {
    // the div loads its content!
    $(this).addClass('active');
    $container.slideDown();
  }
});

// Ajax resources by author

$('#libraryTabs li a[data-target="#author"]').click(function() {
  var $author_container = $('.ajax__author_content');

  jQuery.ajax({
    type       : "GET",
    data       : { 
      dataType: "jsonp",
      action:'ajax_author_library',
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      if(data.length) {
        var content = data;
        $author_container.empty();
        $(content).hide().appendTo($author_container).fadeIn(300);
      }
    },
  });

})

// Ajax search results

$('#librarySearch').submit(function(e) {
  // don't go to another page
  e.preventDefault();

  var $results_container = $('.library__search_results');

  jQuery.ajax({
    type       : "GET",
    data       : { 
      dataType: "jsonp",
      action:'ajax_search_library',
      query: $('#librarySearch input').val(),
    },
    url: '../../wp-admin/admin-ajax.php',
    success    : function(data){
      if(data.length) {
        data = JSON.parse(data);
        var content = data[0];
        var first_char = data[1];

        $('#librarySearch input').val('');

        $results_container.empty();
        $(content).appendTo($results_container).fadeIn(300);

        // alphabet filter
        $('.alphabet-hide').css({ 'opacity': '1', 'height': 'auto'});

        $('.template-library-resources .num').addClass('disabled');
      
        for (var i = 0; i < first_char.length; i++) {
          $('[data-filter="' + first_char[i] + '"]').removeClass('disabled');
          $('[data-filter="' + first_char[i] + '"]').attr('href', '#' + first_char[i]);
        }

      }
    },
  });
});

// Collapse nav tabs

$(function() {
 
  // Create the dropdown base
  $('<div class="mobile-nav"></div>').appendTo('#libraryTabs');
  $('<select></select>').appendTo('#libraryTabs .mobile-nav');

  // Populate dropdown with menu items
  $('#libraryTabs a').each(function() {
    var el = $(this);
    $('<option />', {
      'value'   : el.attr('data-target'),
      'text'    : el.text()
    }).appendTo('#libraryTabs select');
    // tabs apparently need to each be enabled separately
    $(el).click(function (e) {
      e.preventDefault()
      $(this).tab('show');
    })
  }); 

  // To make dropdown actually work
  $('#libraryTabs select').change(function() {
    var tab = $(this).find("option:selected").val();
    if( tab == '#search') {
      $('.alphabet-filter').fadeIn();
    } else {
      $('.alphabet-filter').fadeOut();
    }
    $('#libraryTabs a[data-target="' + tab + '"]').click();
  });

});



// WEBPACK FOOTER //
// ./scripts/routes/library.js